<template>
  <v-card
    v-if="voucherContent"
    border
    height="100%"
  >
    <v-card-title class="my-4">
      <div
        v-if="voucherContent.title"
        class="text-h6 d-flex align-center justify-center"
      >
        <r-img
          class="voucher-logo"
          max-height="60px"
          max-width="60px"
          :src="voucherContent.logo"
        />
        <h3 class="px-4">
          {{ $t(voucherContent.title) }}
        </h3>
      </div>
      <r-img
        v-else
        class="voucher-logo"
        cover
        max-height="60px"
        :src="voucherContent.logo"
      />
    </v-card-title>

    <v-card-subtitle class="pt-2 mx-2 text-subtitle-2 font-weight-bold text-wrap">
      {{ $t(voucherContent.subTitle) }}
    </v-card-subtitle>

    <v-card-text class="px-6">
      <div class="my-2 text-overflow">
        <p
          v-for="(text, index) in voucherContent.text"
          :key="index"
          class="mb-4"
        >
          {{ $t(text) }}
        </p>
        <p
          v-for="(entry, index) in voucherContent.textWithLink"
          :key="`link-${index}`"
          class="mb-4"
        >
          {{ $t(entry.text) }}
          <a
            v-if="entry.link"
            :href="$t(entry.link)"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t(entry.link) }}
          </a>
        </p>
        <p v-if="voucherContent.supportMail">
          {{ $t('partner.voucher.get-support') }}:
          <a :href="`mailto:${$t(voucherContent.supportMail)}`">
            {{ $t(voucherContent.supportMail) }}
          </a>
        </p>
      </div>

      <v-row
        class="my-6"
        align="center"
        justify="space-around"
      >
        <v-text-field
          v-if="voucher.code"
          class="mx-2 mb-4 shrink voucher-code"
          :label="$t('partner.voucher.label')"
          variant="outlined"
          readonly
          hide-details
          @copy="$tracking.event('Partner', 'Copy Voucher', voucher.type, voucher.code)"
          :model-value="voucher.code"
        />
        <v-text-field
          v-else-if="voucherContent.code"
          class="mx-2 mb-4 shrink voucher-code"
          :label="$t('partner.voucher.label')"
          variant="outlined"
          readonly
          hide-details
          @copy="$tracking.event('Partner', 'Copy Voucher', voucher.type, voucherContent.code)"
          :model-value="voucherContent.code"
        />

        <v-btn
          size="x-large"
          class="mx-2 mb-4 primary"
          :href="$t(voucherContent.registrationLink)"
          @click="$tracking.event('Partner', 'Clicked', voucher.type)"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{
            voucherContent?.registrationLinkText
              ? $t(voucherContent.registrationLinkText)
              : $t('buttons.partner.voucher.cta')
          }}
          <v-icon
            class="ml-2"
            size="14"
          >
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-row>
      <span v-if="voucher.expiresAt">
        {{ $t('partner.voucher.valid-until') }}: {{ formatDate(voucher.expiresAt) }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDate } from '@/lib/dateTime'
import brandingMixin from '@/mixins/branding'

import { PARTNER_TYPES } from './helper/partner'

export default {
  mixins: [brandingMixin],
  props: {
    voucher: {
      type: Object,
      default: null,
    },
  },
  computed: {
    voucherContent() {
      return PARTNER_TYPES[this.platform][this.voucher.type]
    },
  },
  methods: {
    formatDate,
  },
}
</script>

<style scoped>
.subtitle {
  font-weight: bold;
}
.voucher-code :deep(input) {
  text-align: center;
}
.voucher-logo :deep(img) {
  object-fit: contain;
}
.text-overflow {
  max-height: 200px;
  overflow-y: auto;
}
.title {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
</style>
